import { Component, OnInit } from '@angular/core';
import { LayoutService } from './user-area-layout.service';

@Component({
  selector: 'mcb-portal-user-area',
  templateUrl: './user-area-layout.component.html',
})
export class PortalUserAreaLayoutComponent implements OnInit {
  showSidebarClass = '';
  constructor(private layoutService: LayoutService) {
  }

  ngOnInit() {
    this.layoutService.onSideBarToggle.subscribe(showSidebar => {
      if (!showSidebar) {
        this.showSidebarClass = 'mcb-sidebar-hide';
      } else {
        this.showSidebarClass = '';
      }
    });


  }
}
